import convertArrayToObject from '../../utils/arrayOp';
import { sc } from '../../utils/Common';
import { Types } from '../actions/defectActions';

const initialState = {
  filterKey: '',
  filtered: [],
  loading: false,
  error: '',
  selected: [],
  Data: [],
  level1: [],
  level2: [],
  level2Filtered: [],
  level1Selected: 0,
  level2Selected: 0,
  vatType: null
};

export const defectReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_DEFECT_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case Types.RESET_DEFECTS: {
      return {
        ...initialState,
        vatType: state.vatType,
        loading: false,
      };
    }

    case Types.ADD_DEFECTS: {
      return {
        ...state,
        selected: action.payload.defects,
      };
    }

    case Types.GET_DEFECT_SUCCESS: {
      const level1 = [];
      const level2 = [];
      const Level1Map = new Map();
      const Level2Map = new Map();
      for (const item of action.payload) {
        if (!Level1Map.has(item.CategoryLevel1Id)) {
          Level1Map.set(item.CategoryLevel1Id, true); // set any value to Map
          level1.push({
            level1Id: item.CategoryLevel1Id,
            level1Desc: item.CategoryLevel1
          });
        }
        if (!Level2Map.has(item.CategoryLevel2Id)) {
          Level2Map.set(item.CategoryLevel2Id, true); // set any value to Map
          level2.push({
            level2Id: item.CategoryLevel2Id,
            level2Desc: item.CategoryLevel2,
            level1Id: item.CategoryLevel1Id,
            level1Desc: item.CategoryLevel1
          });
        }
      }
      return {
        ...state,
        error: '',
        filtered: action.payload,
        loading: false,
        defectsTable: convertArrayToObject(action.payload, 'Code'),
        Data: action.payload,
        level1,
        level2,
        level2Filtered: level2
      };
    }
    case Types.SET_DEFECT_ERROR: {
      return {
        ...state,
        ...action.payload,
        error: action.payload.error,
        loading: false
      };
    }
    case Types.SET_SELECTION: {
      return {
        ...state,
        selected: [...action.payload.item]
      };
    }
    case Types.SET_CURRENT_DEFECT: {
      return {
        ...state,
        currentDefect: action.payload.value
      };
    }
    case Types.SET_DEFECT_FILTER_KEY: {
      let data = [...state.Data];
      const key = action.payload.filterKey;
      const l1 = parseInt(action.payload.level1Selection, 10);
      const l2 = parseInt(action.payload.level2Selection, 10);
      data = key.length === 0 ? data : data.filter((row) => (sc(row.UserCode, key) || sc(row.DefectDesc, key)));

      if (l1 !== 0) { data = data.filter((d) => d.CategoryLevel1Id === l1); }

      if (l2 !== 0 && l1 !== 0) { data = data.filter((d) => d.CategoryLevel2Id === l2); }
      return {
        ...state,
        filterKey: key,
        level1Selected: l1,
        level2Selected: l2,
        level2Filtered: state.level2.filter((l) => l.level1Id === l1),
        filtered: data
      };
    }
    case Types.SET_VAT_TYPE: {
      return {
        ...state,
        vatType: action.payload.vatType
      }
    }
    default:
      return state;
  }
};
